import styled from "styled-components";
import { themeChangeTime } from "../../styles/global";

export const NavBarBody = styled.div`
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const topBarSize = "4rem";
export const leftBarSize = "15%";

export const TopBar = styled.div`
  background-color: ${(props) => props.theme.body};
  transition: all ${themeChangeTime};

  position: absolute;
  top: 0%;
  left: calc(${leftBarSize} - 1px);
  width: calc(100% - ${leftBarSize});
  height: ${topBarSize};
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid ${(props) => props.theme.border};
  z-index: 2;
`;

export const LeftBar = styled.div`
  position: absolute;
  top: 0%;
  left: 0%;
  height: 100%;
  width: ${leftBarSize};
  box-shadow: 4px ${topBarSize} 4px 0px rgba(0, 0, 0, 0.2);
  border-right: 1px solid ${(props) => props.theme.border};
  z-index: 1;
`;

const IconSettings = {
  size: "80px",
};
export const Icon = styled.img`
  position: relative;
  top: ${topBarSize};
  left: 50%;
  width: ${IconSettings.size};
  height: ${IconSettings.size};
  transform: translate(-50%, -50%);

  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);

  z-index: 3;

  margin-bottom: 5rem;

  cursor: pointer;
`;

export const Category = styled.div`
  width: calc(100% - 1rem);

  margin-left: 1rem;
  margin-bottom: 3rem;
`;

export const LeftBarCategory = styled.p`
  text-transform: uppercase;
  font-family: "Roboto";
  font-size: 0.7rem;
  color: #374957;
  font-weight: 900;

  margin-bottom: 0.5rem;
`;
export const LeftBarSubCategory = styled.p`
  font-family: "Roboto";
  font-size: 1rem;
  font-weight: 900;
  margin-top: 0.2rem;
  margin-left: 2rem;
  color: rgba(55, 73, 87, 0.7);

  &:hover {
    cursor: pointer;
    color: rgba(55, 73, 87, 1);
    transition-duration: 0.1s;
  }
`;

export const ThemeSwitch = styled.div`
  position: absolute;
  bottom: 0%;
  width: 100%;
  text-align: center;
`;

const userDivPadding = "5px";
export const UserDiv = styled.div`
  position: absolute;
  top: 0rem;
  right: 0rem;
  height: calc(${topBarSize} - ${userDivPadding});
  padding: ${userDivPadding};
  padding-right: 20px;
  & * {
    float: right;
  }

  cursor: pointer;

  &:hover {
    opacity: 0.8;
    transition: all 0.1s;
  }
`;
export const UserTitle = styled.p`
  text-align: end;

  margin: 5px;

  font-family: "Roboto";
  font-size: 1rem;
  color: #374957;
  font-weight: 900;
`;
export const UserIcon = styled.img`
  width: calc(${topBarSize} - 1rem);
  height: calc(${topBarSize} - 1rem);
  border-radius: 50px;

  border: 1px solid #00000033;
`;
